import { api } from '@setplex/tria-api'
import { combine } from 'effector'
import { model as i18n } from '~/core/i18n'
import { ssePurchasesModel } from '~/features/payment/sse-purchases'
import { extendMediaItemByLabelPrice } from '~/shared/tools'

export const $subCategoriesWithVodsFormatted = combine(
  api.vods.$subCategoriesWithVods,
  ssePurchasesModel.$vod,
  i18n.$t,
  (subCategoriesWithVods, adjust, { t }) => {
    const data =
      subCategoriesWithVods?.length > 0
        ? subCategoriesWithVods.map((category) => {
            const vods = category.content.map((vod) =>
              extendMediaItemByLabelPrice(adjust(vod))
            )
            const genresText = t('genre_other')

            return {
              ...category,
              content: vods,
              nameFormatted: `${category.name} ${genresText}`,
            }
          })
        : null

    return data
  }
)
